module.exports = __webpack_public_path__ + "img/logoCompany.2d782e0f.png";